import React from "react";
import { 
  ValuesSectionWrapper,
  ValuesContainer,
  LeftSection,
  RightSection,
  ImageContainer,
  MainImageBg,
  BadgeAventure,
  OrangeIcon,
  SupportCard,
  SupportTitle,
  SupportText,
  WhatsAppIconWrapper,
  AuthorCard,
  AuthorAvatar,
  AuthorInfo,
  AuthorName,
  AuthorRole,
  ViewButton,
  SectionTitle,
  IntroText,
  ValueItem,
  ValueIcon,
  ValueContent,
  ValueTitle,
  ValueDescription,
  CtaButton,
  ContentImgLeft,
  ContentDetailsRight,
  DevisButton
} from "./Values.styles";
import { SpotifyIcon, TriangleIcon } from "../shared/icons";
import hero1 from "../../assets/hero1.png";
import vector1 from "../../assets/Vector1.png";
import vector2 from "../../assets/Vector2.png";
import avatar from "../../assets/avatar.png"; // Import de l'image avatar

// Icône Message avec votre SVG en BLANC
const MessageIcon = () => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    fill="none" 
    viewBox="0 0 24 24" 
    strokeWidth="1.5" 
    stroke="white"
    style={{ width: '1.75vw', height: '1.75vw' }}
  >
    <path 
      strokeLinecap="round" 
      strokeLinejoin="round" 
      d="M8.625 12a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H8.25m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H12m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0h-.375M21 12c0 4.556-4.03 8.25-9 8.25a9.764 9.764 0 0 1-2.555-.337A5.972 5.972 0 0 1 5.41 20.97a5.969 5.969 0 0 1-.474-.065 4.48 4.48 0 0 0 .978-2.025c.09-.457-.133-.901-.467-1.226C3.93 16.178 3 14.189 3 12c0-4.556 4.03-8.25 9-8.25s9 3.694 9 8.25Z" 
    />
  </svg>
);

// Nouvelle icône Bullseye (cible) pour PRÊT-SUIVRE L'AVENTURE
const BullseyeIcon = () => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    height="24px" 
    viewBox="0 -960 960 960" 
    width="24px" 
    fill="#161645"
    style={{ width: '1.75vw', height: '1.75vw' }}
  >
    <path d="M480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-80q-100 0-170-70t-70-170q0-100 70-170t170-70q100 0 170 70t70 170q0 100-70 170t-170 70Zm0-80q66 0 113-47t47-113q0-66-47-113t-113-47q-66 0-113 47t-47 113q0 66 47 113t113 47Zm0-80q-33 0-56.5-23.5T400-480q0-33 23.5-56.5T480-560q33 0 56.5 23.5T560-480q0 33-23.5 56.5T480-400Z"/>
  </svg>
);

const Values = () => {
  return (
    <ValuesSectionWrapper>
      <ValuesContainer>
        <LeftSection>
          <ContentImgLeft className="content-img-left relative flex row center">
            <ImageContainer>
              <MainImageBg>
                <img src={hero1} alt="Nos valeurs" />
              </MainImageBg>

              {/* Badge PRÊT-SUIVRE L'AVENTURE */}
              <BadgeAventure>
                PRÊT-SUIVRE L'AVENTURE
              </BadgeAventure>
              
              {/* Icône Bullseye dans le cercle orange */}
              <OrangeIcon>
                <BullseyeIcon />
              </OrangeIcon>

              {/* Card 24HR SUPPORT */}
              <SupportCard>
                <SupportTitle>24HR SUPPORT</SupportTitle>
                <SupportText>
                  Profitez de nos tarifs élèves heed attentive of the day from our list of professionals
                </SupportText>
              </SupportCard>

              {/* Icône Message en BLANC */}
              <WhatsAppIconWrapper>
                <MessageIcon />
              </WhatsAppIconWrapper>

              {/* Card Auteur - AVATAR REMPLACÉ PAR IMAGE */}
              <AuthorCard>
                <AuthorAvatar>
                  <img 
                    src={avatar} 
                    alt="Lateef Afolabi" 
                    style={{ 
                      width: '100%', 
                      height: '100%', 
                      objectFit: 'cover',
                      borderRadius: '0.625vw'
                    }} 
                  />
                </AuthorAvatar>
                <AuthorInfo>
                  <AuthorName>Lateef Afolabi</AuthorName>
                  <AuthorRole>Senior Stylist</AuthorRole>
                </AuthorInfo>
                <ViewButton>Demander un Devis</ViewButton>
              </AuthorCard>
            </ImageContainer>
          </ContentImgLeft>
        </LeftSection>

        <ContentDetailsRight className="content-details-right flex col">
          <SectionTitle>Nos Valeurs ajoutées</SectionTitle>
          <IntroText>
            Lorem officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud amet
          </IntroText>

          <ValueItem>
            <ValueIcon $spotify>
              <img src={vector1} alt="Créativité" style={{ width: '1.625vw', height: '1.625vw' }} />
            </ValueIcon>
            <ValueContent>
              <ValueTitle>Créativité , Dynamisme & Rapidité</ValueTitle>
              <ValueDescription>
                Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud amet
              </ValueDescription>
            </ValueContent>
          </ValueItem>

          <ValueItem>
            <ValueIcon $funnel>
              <img src={vector2} alt="Loyauté" style={{ width: '1.625vw', height: '1.625vw' }} />
            </ValueIcon>
            <ValueContent>
              <ValueTitle>Loyauté , Disponibilité & Innovation</ValueTitle>
              <ValueDescription>
                Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud amet
              </ValueDescription>
            </ValueContent>
          </ValueItem>

          <CtaButton>
            <DevisButton>
              DEMANDER UN DEVIS
            </DevisButton>
          </CtaButton>
        </ContentDetailsRight>
      </ValuesContainer>
    </ValuesSectionWrapper>
  );
};

export default Values;